import React, { useState, useEffect } from "react";
import Months from "features/CalendarView/Months";
import { DateHelper } from "shared/helpers/DateHelper";

export default function MonthsShared(props) {
  const {
    direction,
    dateHelper,
    lastDay,
    calendarItems,
    setScrollToLocation,
  } = props;
  const [months, setMonths] = useState(
    dateHelper.generateMonthsThrough(monthGenParams())
  );
  const [cnObj, setCnObj] = useState(makeCnObj([calendarItems]));

  useEffect(() => {
    setCnObj(makeCnObj(calendarItems));
    if (direction === "reverse") {
      const firstItemDay = DateHelper.parseDate(
        calendarItems[calendarItems.length - 1].day
      );
      dateHelper.startDate = new Date(
        getFirstYear() - 8,
        firstItemDay.getMonth(),
        firstItemDay.getDate()
      );
      setMonths(dateHelper.generateMonthsThrough(monthGenParams()));
    }
  }, [calendarItems]);

  useEffect(() => {
    setMonths(dateHelper.generateMonthsThrough(monthGenParams()));
  }, [direction, dateHelper.firstYear]);

  useEffect(() => {
    if (direction === "reverse") {
      setScrollToLocation("bottom");
    }
  }, [months]);

  function monthGenParams() {
    switch (direction) {
      case "forward":
        return { endYear: lastYear() + 8 };
      case "reverse":
        return { startDate: dateHelper.startDate };
      default:
        return { endYear: lastYear() + 8 };
    }
  }

  function lastYear() {
    return Number.parseInt(lastDay.slice(0, 4));
  }

  function getFirstYear() {
    if (calendarItems && calendarItems[0]) {
      return Number.parseInt(calendarItems[0].day.slice(0, 4));
    } else {
      return null;
    }
  }

  function makeCnObj(calendarItems) {
    return calendarItems.reduce((acc, item) => {
      if (acc[item.day] === undefined) {
        acc[item.day] = {
          calendarNotes: [],
          continuingCalendarNotes: [],
        };
      }
      if (item.type === "calendar_note") {
        acc[item.day].calendarNotes.push(item);
      }
      if (item.type === "continuing_calendar_note") {
        acc[item.day].continuingCalendarNotes.push(item);
      }
      return acc;
    }, {});
  }

  return <Months {...{ ...props, months, setMonths, cnObj }} />;
}

function monthsAreEqual(prevProps, nextProps) {
  return (
    prevProps.lastDay === nextProps.lastDay &&
    prevProps.selectedDate === nextProps.selectedDate &&
    prevProps.activeDate === nextProps.activeDate &&
    prevProps.itemType === nextProps.itemType &&
    prevProps.scrollOffset === nextProps.scrollOffset &&
    prevProps.scrollToLocation === nextProps.scrollToLocation &&
    prevProps.calendarItems === nextProps.calendarItems &&
    prevProps.direction === nextProps.direction
  );
}

export const MemoizedMonths = React.memo(MonthsShared, monthsAreEqual);
